import { render, staticRenderFns } from "./GroupTemplateChoice.vue?vue&type=template&id=d989e0f8&scoped=true&"
import script from "./GroupTemplateChoice.vue?vue&type=script&lang=js&"
export * from "./GroupTemplateChoice.vue?vue&type=script&lang=js&"
import style0 from "./GroupTemplateChoice.vue?vue&type=style&index=0&id=d989e0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d989e0f8",
  null
  
)

export default component.exports